export default function WhyFintoo() {
  return (
    <section
      id="why-fintoo"
      className="lg:tw-py-20 tw-py-10 tw-bg-gradient-to-r tw-from-gray-50 tw-to-blue-50 tw-relative"
    >
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6 ">
            More than just a comparison tool — We’re your trusted guide.
          </h2>
          <p className="tw-text-lg  lg:tw-text-xl  tw-text-gray-700 tw-max-w-4xl tw-mx-auto">
            We're not here to sell you a policy. We're here to guide you. At
            Fintoo, we help you compare, understand, and pick the plan that
            suits your family best.
          </p>
        </div>

        <div className="tw-grid lg:tw-grid-cols-3 tw-gap-8">
          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-8 tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-14 tw-h-14 tw-bg-fintoo-orange tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-6">
              <i className="fa-solid fa-balance-scale tw-text-white tw-text-xl"></i>
            </div>
            <h3 className="tw-text-2xl tw-font-bold tw-text-fintoo-blue tw-mb-4 tw-pb-0">
              Compare Across Insurers
            </h3>
            <p className="tw-text-gray-600 tw-leading-relaxed">
              Transparent side-by-side analysis.
            </p>
          </div>

          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-8 tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-14 tw-h-14 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-6">
              <i className="fa-solid fa-comments tw-text-white tw-text-xl"></i>
            </div>
            <h3 className="tw-text-2xl tw-font-bold tw-text-fintoo-blue tw-mb-4 tw-pb-0">
              Human-Friendly Explanations
            </h3>
            <p className="tw-text-gray-600 tw-leading-relaxed">
              No jargon, only clarity.
            </p>
          </div>

          <div className="tw-bg-white/80 tw-backdrop-blur-sm tw-rounded-2xl tw-p-8 tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            <div className="tw-w-14 tw-h-14 tw-bg-fintoo-orange tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-6">
              <i className="fa-solid fa-handshake tw-text-white tw-text-xl"></i>
            </div>
            <h3 className="tw-text-2xl tw-font-bold tw-tesxt-fintoo-blue tw-mb-4 tw-pb-0">
              End-to-End Support
            </h3>
            <p className="tw-text-gray-600 tw-leading-relaxed">
              From choosing to claiming, we’re with you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
